import { ContextService } from '../../../services/context_service';
import { lazyInject } from '../../../services/inversify';
import { PvToolEegVerguetung } from './PvToolEegVerguetung';
import { PvToolErzeugungsLastdaten } from './PvToolErzeugungsLastdaten';
import { PvToolParameter } from './PvToolParameter';
import * as React from 'react';
import { Routing } from '../../../helpers/Routing';
import { RoutingIDs } from '../../../helpers/RoutingAdminIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

interface PvToolProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
}

interface PvToolState {
    tabIndex: number;
}

export class PvTool extends React.Component<PvToolProps, PvToolState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: null
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;

    private disabled: string[] = [];
    private prefix: string = 'admin.tab.pv_tool';
    private rechte: any = {};
    private tabName: string = RoutingIDs.TABS_PV_TOOL;
    private tabIndex: string = `${this.tabName}Index`;
    private tabRoutings: any[] = [
        { path: RoutingIDs.ROUTE_PV_TOOL_ERZEUGUNGSDATEN_LASTDATEN },
        { path: RoutingIDs.ROUTE_PV_TOOL_EEG_VERGUETUNG },
        { path: RoutingIDs.ROUTE_PV_TOOL_PARAMETER }
    ];
    private tabs: string[] = ['daten', 'eeg', 'parameter']; // Reitereihenfolge beachten

    componentDidMount(): void {
        (new Routing(this)).init((rechte: any, tabIndex: number) => {
            this.rechte = rechte || {};
            this.setTabIndex(tabIndex, this.tabRoutings[tabIndex]);
        });
    }

    componentDidUpdate(prevProps: any): void {
        if (JSON.stringify(this.props.routing) !== JSON.stringify(prevProps.routing)) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        if (typeof (routing.path || {})[this.tabName] === 'undefined') {
            return;
        }
        // this.setTabIndex(routing.path[this.tabName], routing, () => {
        //     if (routing.path.terminateOn === this.tabName) {
        //         this.props.onRoutingChange({});
        //     }
        // });
        if (this.state.tabIndex === routing.path[this.tabName]) {
            if (routing.path.terminateOn === this.tabName) {
                this.props.onRoutingChange({});
            }
        } else {
            this.setTabIndex(routing.path[this.tabName], routing);
        }
    }

    render(): JSX.Element {
        if (this.state.tabIndex === null) {
            return null;
        }

        return (
            <Tabs
                className='tabs-admin-pv_tool'
                selectedIndex={this.state.tabIndex}
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, this.tabRoutings[tabIndex])}
            >
                <TabList>
                    <Tab disabled={!this.rechte.daten}>Erzeugungs- und Lastdaten</Tab>
                    <Tab disabled={!this.rechte.eeg}>EEG-Vergütung</Tab>
                    <Tab disabled={!this.rechte.parameter}>Parameter</Tab>
                </TabList>
                <TabPanel>
                    {this.rechte.daten &&
                        <PvToolErzeugungsLastdaten {...this.props} />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.eeg &&
                        <PvToolEegVerguetung />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.parameter &&
                        <PvToolParameter />
                    }
                </TabPanel>
            </Tabs>
        );
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void): void {
        if (this.state.tabIndex !== tabIndex) {
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set(this.tabIndex, tabIndex);

                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            });
        }
    }
}
